const Login = () => {
  return (
    <>
      <h2>Login page</h2>
    </>
  );
};

export default Login;
